import { EPlatform } from '@/types/platform.ts';
import type { TPlatform as _TPlatform } from '@/types/platform.ts';
import MpWxSetup from '@/platforms/MpWx.ts';
import WebSetup from '@/platforms/Web.ts';
import { getStorage, setStorage } from '@/utils/storager';
import { sessionIdStorageKey } from '@/constants/commonConst.ts';
import WxRequest from '@/requestInstance/WxRequest.ts';
import WebFetch from '@/requestInstance/WebFetch.ts';
import { getMpWxStorage, setMpWxStorage } from '@/utils/storager/mpWxStorager.ts';
import { getWebStorage, setWebStorage } from '@/utils/storager/webStorager.ts';
import { nanoid as nsnanoid } from 'nanoid/non-secure';
import { nanoid } from 'nanoid';

type TPlatform = _TPlatform | string | null | undefined;

class PlatformProxy {
  private static instance: PlatformProxy | null = null;
  public static getInstance(): PlatformProxy {
    if (!PlatformProxy.instance) {
      PlatformProxy.instance = new PlatformProxy();
    }
    return PlatformProxy.instance;
  }
  public platformType: TPlatform = '';
  public storager = {
    setStorageFn: this.getSetStorageFn(),
    getStorageFn: this.getGetStorageFn(),
  };
  private traceSessionId = '';
  private sessionId = '';
  private constructor() {}

  public init({ platform }: { platform?: TPlatform }) {
    console.log('Platform Proxy Inited');
    if (this.platformType && platform) {
      console.warn('【WARNING】平台已被设置，重复设置可能会覆盖之前的值');
    }
    this.setPlatform(platform);

    switch (this.platformType) {
      case EPlatform.MPWX:
        this.traceSessionId = nsnanoid(36);
        this.sessionId = `${this.traceSessionId}:${nsnanoid()}`;
        break;
      case EPlatform.WEB:
        this.traceSessionId = nanoid(36);
        this.sessionId = getStorage(sessionIdStorageKey, 'default') || `${this.traceSessionId}:${nanoid()}`;
        setStorage(sessionIdStorageKey, this.sessionId);
        break;
    }
    console.log('Platform Proxy Inited END');
  }
  public getSessions(): { traceSessionId: string; sessionId: string } {
    return {
      traceSessionId: this.traceSessionId,
      sessionId: this.sessionId,
    };
  }
  public autoTrack(obj) {
    switch (this.platformType) {
      case EPlatform.MPWX:
        console.log('platform switch: mp-wx');
        // eslint-disable-next-line new-cap,no-new
        new MpWxSetup({
          ...obj,
        });
        break;
      case EPlatform.WEB:
        // eslint-disable-next-line no-new
        new WebSetup({
          ...obj,
        });
        break;
    }
  }
  public setStoreBaseData(baseData) {
    let routeArr: any[];
    let currRoute: any;
    switch (this.platformType) {
      case EPlatform.MPWX:
        if (!baseData?.appId) {
          baseData.appId = wx.getAccountInfoSync().miniProgram.appId;
        }
        routeArr = getCurrentPages();
        console.log('routeArr: ', routeArr);
        if (routeArr.length) {
          currRoute = routeArr[routeArr.length - 1];
          baseData.pageName = currRoute.route;
        }
        break;
      case EPlatform.WEB:
        baseData.pageName = `${location.origin}${location.pathname}`;
        break;
    }
  }
  public getReqInstance(config) {
    switch (this.platformType) {
      case EPlatform.MPWX:
        return new WxRequest(config);
      case EPlatform.WEB:
        return new WebFetch({ ...config, baseURL: config.baseUrl });
      // break;
    }
  }
  private getSetStorageFn() {
    switch (this.platformType) {
      case EPlatform.MPWX:
        return setMpWxStorage;
      case EPlatform.WEB:
        return setWebStorage;
    }
  }
  private getGetStorageFn() {
    switch (this.platformType) {
      case EPlatform.MPWX:
        return getMpWxStorage;
      case EPlatform.WEB:
        return getWebStorage;
    }
  }
  private setPlatform(val: TPlatform) {
    let _platform = val;
    if (!_platform) {
      if (typeof wx !== 'undefined' && !wx?.checkJsApi) {
        _platform = EPlatform.MPWX;
      } else if (typeof window !== 'undefined') {
        _platform = EPlatform.WEB;
      } else {
        _platform = undefined;
      }
    }
    this.platformType = _platform;
  }
}

export default PlatformProxy;
